import { GridColDef, GridColumnHeaderParams } from '@mui/x-data-grid-premium'
import { Stack, Typography } from '@mui/material'
import { theme, TableCell } from '@ketch-com/deck'

export interface RightRow {
  id: string
  right: string
  code: string
  total: number
  complete: number
  rejected: number
  duplicates: number
  fulfilledOnTime: string
  meanFulfillmentTime: string
  medianFulfillmentTime: string
  volumeDistribution: string
}

export const rightsDataGridColumns: GridColDef<RightRow>[] = [
  {
    align: 'left',
    field: 'right',
    headerName: 'Right',
    flex: 3,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Right
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Stack>
          <Typography variant="label">{params.row.right}</Typography>
          <Typography variant="body" color={theme.palette.Text.Secondary}>
            {params.row.code}
          </Typography>
        </Stack>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'total',
    headerName: 'Total',
    flex: 0.8,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Total
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value.toLocaleString()}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'complete',
    headerName: 'Complete',
    flex: 0.8,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Complete
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'rejected',
    headerName: 'Rejected',
    flex: 0.8,
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Rejected
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'duplicates',
    headerName: 'Duplicates',
    flex: 0.8,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Duplicates
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'fulfilledOnTime',
    headerName: 'Fulfilled On Time',
    flex: 1,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography variant="smallLabel" color={theme.palette.Text.Secondary}>
        Fulfilled On Time
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'meanFulfillmentTime',
    headerName: 'Mean Fulfillment',
    flex: 0.8,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography
        variant="smallLabel"
        color={theme.palette.Text.Secondary}
        sx={{ whiteSpace: 'normal', lineHeight: 1.2, wordBreak: 'break-word' }}
      >
        Mean Fulfillment
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'medianFulfillmentTime',
    headerName: 'Median Fulfillment',
    flex: 0.8,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography
        variant="smallLabel"
        color={theme.palette.Text.Secondary}
        sx={{ whiteSpace: 'normal', lineHeight: 1.2, wordBreak: 'break-word' }}
      >
        Median Fulfillment
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
  {
    align: 'left',
    field: 'volumeDistribution',
    headerName: 'Volume Distribution',
    flex: 0.8,
    headerAlign: 'left',
    sortable: true,
    renderHeader: (params: GridColumnHeaderParams<RightRow>) => (
      <Typography
        variant="smallLabel"
        color={theme.palette.Text.Secondary}
        sx={{ whiteSpace: 'normal', lineHeight: 1.2, wordBreak: 'break-word' }}
      >
        Volume Distribution
      </Typography>
    ),
    renderCell: params => (
      <TableCell>
        <Typography variant="body">{params.value}</Typography>
      </TableCell>
    ),
  },
]
